import React, { useState, useRef, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const PptxContentBlock = ({ isSelected, block, slideIndex, shapeIndex, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const editableDivRef = useRef(null);
    const previousTextRef = useRef('');
    console.log("PptxContentBlock render:", isSelected);

    // Combine all segments into a single text string
    const combinedText = block.map(segment => segment.text).join('');

    useEffect(() => {
        previousTextRef.current = combinedText;
        updateDisplayContent();
    }, [block]);

    const updateDisplayContent = () => {
        if (editableDivRef.current && !isEditing) {
            // Set plain text content (like textarea)
            editableDivRef.current.textContent = combinedText;
        }
    };

    const handleFocus = () => {
        setIsEditing(true);
        previousTextRef.current = editableDivRef.current?.textContent || '';

        // Don't select all text, just place cursor at the end
        setTimeout(() => {
            if (editableDivRef.current) {
                placeCursorAtEnd(editableDivRef.current);
            }
        }, 10);
    };

    const handleBlur = () => {
        setIsEditing(false);
        saveChanges();
        updateDisplayContent();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            editableDivRef.current?.blur();
        }
        if (e.key === 'Escape') {
            // Restore original text
            if (editableDivRef.current) {
                editableDivRef.current.textContent = previousTextRef.current;
            }
            setIsEditing(false);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();

        // Get plain text from clipboard
        const text = (e.clipboardData || window.clipboardData).getData('text/plain');

        // Insert text at cursor position (like textarea behavior)
        document.execCommand('insertText', false, text);
    };

    const placeCursorAtEnd = (element) => {
        // Place cursor at the end of the text
        const range = document.createRange();
        const selection = window.getSelection();

        range.selectNodeContents(element);
        range.collapse(false); // false means collapse to end

        selection.removeAllRanges();
        selection.addRange(range);
    };

    const saveChanges = () => {
        if (!editableDivRef.current) return;

        const newText = editableDivRef.current.textContent || '';

        // Only update if text actually changed
        if (newText !== previousTextRef.current) {
            // Distribute the edited text back to segments
            const updatedSegments = distributeTextToSegments(block, newText);

            if (onUpdate) {
                onUpdate(slideIndex, shapeIndex, updatedSegments);
            }

            previousTextRef.current = newText;
        }
    };

    const distributeTextToSegments = (originalSegments, newText) => {
        const updatedSegments = [];
        let currentPosition = 0;

        originalSegments.forEach((segment, index) => {
            if (index === originalSegments.length - 1) {
                // Last segment takes all remaining text
                const segmentText = newText.slice(currentPosition);
                updatedSegments.push({
                    ...segment,
                    text: segmentText
                });
            } else {
                // Try to maintain original segment length
                const segmentText = newText.slice(currentPosition, currentPosition + segment.text.length);
                updatedSegments.push({
                    ...segment,
                    text: segmentText
                });
                currentPosition += segmentText.length;
            }
        });

        return updatedSegments;
    };
    
    function getRandomNumber() {
        return Math.floor(Math.random() * 10) + 90;
    }

    return (
        <div className='d-flex gap-2 align-items-start'>
                   <div>
                       <OverlayTrigger
                           placement="top"
                           overlay={
                               <Tooltip id="tooltip">
                                   Machine Translation Quality Prediction: Score indicating translation quality. High quality: above 0.75
                               </Tooltip>
                           }
                       >
                           <span className="bg-primary text-small fs_12 px-2 py-1 text-white rounded">
                               {getRandomNumber()}
                           </span>
                       </OverlayTrigger>
                   </div>
            <div
                ref={editableDivRef}
                contentEditable={true}
                suppressContentEditableWarning={true}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                className="p-2 auto-resize-textarea"
                style={{
                    width: '100%',
                    border: '1px solid #ffffffff',
                    backgroundColor: isSelected ? '#ffffff' :'',
                    borderRadius: '4px',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    resize: 'none',
                    outline: 'none',
                    fontFamily: 'inherit',
                    textAlign: "start",
                    overflow: 'hidden'
                }}
            />
        </div>
    );
};

export default PptxContentBlock;